import React, { FC, useRef, useState } from "react"
import { Form, Modal, Select } from "antd"
import { observer } from "mobx-react"

import { useStore } from "stores/utils/use-store"
import { LootboxType, PremiumRewardType } from "domains/accounts/store/types"
import { SubmitCancelButtons, FormElement } from "components"

const { Option } = Select

export const GrantLootbox: FC<{
  visible: boolean;
  onClose: () => void;
  onSuccess?: () => void;
}> = observer(({ visible, onClose, onSuccess }) => {
  const formRef: any = useRef()
  const [selectedType, setSelectedType] = useState<LootboxType>()
  const { dataStore: { accountDetailsStore } } = useStore()

  const onFinishHandler = async(el: {
    count: number;
    type: LootboxType;
    premiumRewardType?: string;
  }) => {
    const submitData: any = {
      count: el.count,
      type: el.type,
    }
    if (el.premiumRewardType) {
      submitData.premiumRewardType = el.premiumRewardType
    }
    accountDetailsStore.funcAfterSuccess = async() => {
      onClose()
      formRef.current?.resetFields()
      setSelectedType(undefined)
      accountDetailsStore.resetFuncAfterSuccess()
      if (onSuccess) {
        onSuccess()
      }
    }
    await accountDetailsStore.grantLootboxes(submitData)
  }

  return (
    <Modal
      visible={visible}
      title="Grant Lootbox"
      footer={null}
      onCancel={() => {
        onClose()
        formRef.current?.resetFields()
        setSelectedType(undefined)
      }}
    >
      <Form onFinish={onFinishHandler} ref={formRef}>
        <FormElement
          type="inputNumber"
          label="Count"
          name="count"
          required
          props={{ style: { width: "100%" }, min: 1 }}
        />
        <Form.Item
          label="Type"
          name="type"
          rules={[
            {
              required: true,
              message: "Please select Type!",
            },
          ]}
        >
          <Select
            onChange={(item: LootboxType) => {
              setSelectedType(item)
              if (item === LootboxType.REGULAR) {
                formRef.current?.setFieldsValue({ premiumRewardType: undefined })
              }
            }}
          >
            <Option value={LootboxType.REGULAR} key={0}>
              REGULAR
            </Option>
            <Option value={LootboxType.PREMIUM} key={1}>
              PREMIUM
            </Option>
          </Select>
        </Form.Item>
        {selectedType === LootboxType.PREMIUM && (
          <Form.Item
            label="Premium Reward Type"
            name="premiumRewardType"
          >
            <Select allowClear>
              {Object.values(PremiumRewardType).map((value, i) => (
                <Option value={value} key={i}>{value}</Option>
              ))}
            </Select>
          </Form.Item>
        )}

        <SubmitCancelButtons onClose={onClose} isLoading={accountDetailsStore.isLoading} />
      </Form>
    </Modal>
  )
})

